module.exports = __webpack_public_path__ + "img/w75.89d8cf61.svg";